<template>
  <div>
    <master-bl-list />
  </div>
</template>

<script>
import MasterBlList from '@/components/resources/MasterBlList'
export default {
  components: {
    MasterBlList
  },
  mounted() {
    this.$mpTrack('Master BI List page mounted')
  }
}
</script>
